/* @ngInject */
const pieceAsk = (
  utils,
  pieceLabels,
  pieceRequest,
  toaster,
  valueHandler,
  saleData
) => {
  const self = {}

  self.delete = async (_id, _back = false) => {
    if (valueHandler.isId(_id.id)) { _id = _id.id }

    if (toaster.confirm(pieceLabels.ask.delete)) {
      try {
        const message = await pieceRequest.delete(_id)
        toaster.message(message)
        utils.removeFromArray(saleData.mySale.steriles, _id)
        if (_back) { utils.$back() }
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  return self
}
export default pieceAsk



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/piece/services/ask.service.js